import {Button, Input, Upload} from 'antd';
import {RcFile} from 'antd/es/upload';
import cn from 'classnames';
import React, {MouseEvent} from 'react';

import {ReactComponent as ClearIcon} from 'shared/assets/forms/delete-x.svg';
import {ReactComponent as FileIcon} from 'shared/assets/forms/file.svg';
import {IFormItemProps} from 'shared/types';

import s from './file-uploader.module.less';

interface IFileUploaderProps extends IFormItemProps{
    accept?: string;
    disabled?: boolean;
    multiple?: boolean;
}

export const FileUploader = ({
    accept,
    disabled,
    multiple = false,
    value: fieldValue,
    onChange,
}: IFileUploaderProps) => {
    const handleUpload = (file: RcFile, fileList: RcFile[]) => {
        const value = multiple ? fileList : file;
        if (!fieldValue || !multiple) onChange?.(value, undefined);
        if (multiple && Array.isArray(fieldValue)) {
            const uploadedFileNames = fieldValue.map(uploadedFile => uploadedFile.name);
            const uniqueFiles = fileList.filter(newFile => !uploadedFileNames.includes(newFile.name));
            onChange?.(fieldValue.concat(uniqueFiles), undefined);
        }

        return false;
    };

    const handleRemove = (index?: number) => {
        if (index === undefined) onChange?.(undefined, undefined);
        else if (Array.isArray(fieldValue)) {
            onChange?.((() => {
                const filteredArray = fieldValue.filter((v, i) => i !== index);
                if (!filteredArray.length) return undefined;
                return filteredArray;
            })(), undefined);
        }
    };

    return (
        <Upload
            accept={accept}
            disabled={disabled}
            beforeUpload={handleUpload}
            showUploadList={false}
            className={s['upload-field']}
            multiple={multiple}
        >
            <div className={s['upload-field-wrapper']}>
                {Array.isArray(fieldValue) ? (
                    <div className={s['file-uploader__multiple-fields']}>
                        {fieldValue.map((file: RcFile, index) => (
                            <Input
                                key={file.uid}
                                disabled
                                prefix={<FileIcon />}
                                className={s['file-uploader__input']}
                                suffix={(
                                    <ClearIcon
                                        className={s['upload-field__clear-icon']}
                                        onClick={(event: MouseEvent<SVGSVGElement>) => {
                                            event.stopPropagation();
                                            handleRemove(index);
                                        }}
                                    />
                                )}
                                value={file.name ?? 'Файл не прикреплен'}
                            />
                        ))}
                    </div>
                ) : (
                    <Input
                        disabled
                        prefix={<FileIcon />}
                        className={s['file-uploader__input']}
                        suffix={(
                            <ClearIcon
                                className={s['upload-field__clear-icon']}
                                onClick={(event: MouseEvent<SVGSVGElement>) => {
                                    event.stopPropagation();
                                    handleRemove();
                                }}
                            />
                        )}
                        value={fieldValue?.name ?? (multiple ? 'Файлы не прикреплены' : 'Файл не прикреплён')}
                    />
                )}
                <Button className={cn(
                    s['upload-field__btn'],
                    multiple && s['file-uploader__multiple-choose-btn']
                )}>
                    {`Выберите файл${multiple ? 'ы' : ''}`}
                </Button>
            </div>
        </Upload>
    );
};
